(function () {
  const strings = window.FoxTheme?.wishlistStrings;
  if (!strings?.addToWishlist || !strings?.inWishlist) return;

  const TR_ADD = ['favorilere ekle'];
  const TR_IN = ['favorilerinizde', 'favorilerde'];

  const normalize = (text) => (text || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const isWishlisted = (btn) => {
    if (
      btn.matches(
        '[aria-pressed="true"], .is-active, .is-wishlisted, .wishlistr-pdp-btn--active, .wishlistr-pdp-btn--wishlisted, [data-wishlisted="true"], [data-active="true"]'
      )
    ) {
      return true;
    }

    const text = normalize(btn.textContent);
    return TR_IN.some((key) => text.includes(key));
  };

  const containsTurkishLabel = (text) => {
    const normalized = normalize(text);
    return TR_ADD.some((key) => normalized.includes(key)) || TR_IN.some((key) => normalized.includes(key));
  };

  const setTextContent = (node, label) => {
    if (node.nodeType === 3) {
      if (containsTurkishLabel(node.textContent)) {
        node.textContent = label;
      }
      return;
    }

    if (node.nodeType !== 1 || node.tagName === 'SVG') return;

    if (node.childNodes.length === 0) {
      if (containsTurkishLabel(node.textContent)) {
        node.textContent = label;
      }
      return;
    }

    node.childNodes.forEach((child) => setTextContent(child, label));
  };

  const patchButton = (btn) => {
    if (!btn?.classList?.contains('wishlistr-pdp-btn')) return;

    const label = isWishlisted(btn) ? strings.inWishlist : strings.addToWishlist;
    btn.setAttribute('aria-label', label);
    setTextContent(btn, label);

    const labelNode = btn.querySelector('[data-wishlistr-label], .wishlistr-pdp-btn__label');
    if (labelNode && containsTurkishLabel(labelNode.textContent)) {
      labelNode.textContent = label;
    }
  };

  const patchHeart = (btn) => {
    if (!btn?.classList?.contains('wishlistr-heart-btn')) return;

    const label = isWishlisted(btn) ? strings.inWishlist : strings.addToWishlist;
    ['aria-label', 'title'].forEach((attr) => {
      const current = btn.getAttribute(attr);
      if (current !== label && containsTurkishLabel(current)) btn.setAttribute(attr, label);
    });
  };

  const patchAll = (root) => {
    (root || document).querySelectorAll('.wishlistr-pdp-btn').forEach(patchButton);
    (root || document).querySelectorAll('.wishlistr-heart-btn').forEach(patchHeart);
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('.wishlistr-pdp-btn')) patchButton(node);
        if (node.matches?.('.wishlistr-heart-btn')) patchHeart(node);
        patchAll(node);
      });
    });
    patchAll(document);
  });

  patchAll(document);
  document.addEventListener('DOMContentLoaded', () => patchAll(document));
  document.addEventListener('shopify:section:load', () => patchAll(document));
  observer.observe(document.documentElement, { childList: true, subtree: true });

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => patchHeart(mutation.target));
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['aria-label', 'title'], subtree: true });
})();
